module.exports = __webpack_public_path__ + "static/media/win.1bed221e.mp3";